export default "__VITE_ASSET__f72b359a__"